import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Detail, TokenInput, Tooltip } from 'components/common';
import { keywordTypes } from '../config';

const SwitchContainer = styled.div`
  display: flex;
  gap: 0px;
`;

const Button = styled.button`
  padding: 5px 0;
  flex: 1;
  outline: none;
  background-color: ${props => (props.isActive ? '#e6f7ff' : 'white')};
  color: ${props => (props.isActive ? '#1890ff' : '#333')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  transition: all 0.2s ease;
  border: 1px solid ${props => (props.isActive ? '#1890ff' : '#e0e0e0')};
  opacity: ${props => (props.disabled ? 0.6 : 1)};
  white-space: nowrap;
  position: relative;
  z-index: ${props => (props.isActive ? '1' : '0')};

  &:first-child {
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
  }

  &:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
  }

  &:not(:first-child) {
    margin-left: -1px;
  }

  &:hover {
    z-index: 1;
    background-color: ${props =>
      props.disabled
        ? props.isActive
          ? '#e6f7ff'
          : 'white'
        : props.isActive
        ? '#e6f7ff'
        : 'white'};
    border-color: ${props =>
      props.disabled
        ? props.isActive
          ? '#1890ff'
          : '#e0e0e0'
        : props.isActive
        ? '#1890ff'
        : '#1890ff'};
    color: ${props =>
      props.disabled
        ? props.isActive
          ? '#1890ff'
          : '#333'
        : props.isActive
        ? '#1890ff'
        : '#1890ff'};
  }
`;

function Keywords({
  hasKeywords,
  value,
  onChange,
  keywordType,
  onKeywordTypeChange,
  style,
  loading,
  disabled,
}) {
  const renderSwitchContainer = () => (
    <SwitchContainer>
      <Button
        isActive={keywordType === keywordTypes.default}
        onClick={() => !disabled && onKeywordTypeChange(keywordTypes.default)}
        type='button'
        disabled={loading || disabled}
      >
        Use Account keywords
      </Button>

      <Button
        isActive={keywordType === keywordTypes.custom}
        onClick={() => !disabled && onKeywordTypeChange(keywordTypes.custom)}
        type='button'
        disabled={loading || disabled}
      >
        Use Custom keywords
      </Button>

      <Button
        isActive={keywordType === keywordTypes.custonAndDefault}
        onClick={() =>
          !disabled && onKeywordTypeChange(keywordTypes.custonAndDefault)
        }
        type='button'
        disabled={loading || disabled}
      >
        Use Both keywords
      </Button>
    </SwitchContainer>
  );

  return (
    <div style={style}>
      {hasKeywords &&
        (disabled ? (
          <Tooltip
            title='Option disabled because the contact has no activities.'
            placement='top'
          >
            {renderSwitchContainer()}
          </Tooltip>
        ) : (
          renderSwitchContainer()
        ))}

      {keywordType !== keywordTypes.default && (
        <Detail
          label={<>keywords - match with platform data</>}
          style={{
            marginTop: hasKeywords ? '12px' : 0,
            marginBottom: 0,
          }}
        >
          <Tooltip
            title={
              disabled
                ? 'Option disabled because the contact has no activities.'
                : ''
            }
          >
            <div style={{ width: '100%' }}>
              <TokenInput
                placeholder='Keywords'
                value={value}
                onChange={value => onChange(value)}
                tokenLimit={10}
                maxTotalCharactersLength={255}
                disabled={loading || disabled}
              />
              <div
                style={{
                  textAlign: 'right',
                  color: '#8D8D8D',
                  fontSize: '13px',
                  marginTop: '3px',
                }}
              >
                {value?.length || 0} / 10
              </div>
            </div>
          </Tooltip>
        </Detail>
      )}
    </div>
  );
}

Keywords.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  hasKeywords: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.shape({}),
};

export default Keywords;
